import { Directive, EventEmitter, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ConfirmNavigation } from '@qv-common/interfaces';

@Directive()
export class ConfirmNavigationUpgrade extends UpgradeComponent {
  @Output()
  public initConfirmNavigation: EventEmitter<ConfirmNavigation>;
}
